import React from 'react'
import './auth.css'
const Register = () => {
  return (
    <div className='register-container'>
      <div className='container-fluid'>
         <div className='row'>
            <div className='col-md-6 '>
                <div className='register-img'>
                </div>
            </div>
            <div className='col-md-6'>
                <div className='register-form'></div>
            </div>
         </div>
      </div>
    </div>
  )
}

export default Register
